'use strict';

var acceptableUserCities = require('./acceptableUserCities');
module.exports = ['Main', 'Washington', 'Portland', 'Boca Raton', 'Columbus'].concat(acceptableUserCities.map(function (city) {
  return city.value;
}));